module.exports = {"130527100":"和阳镇","130527101":"贾宋镇","130527102":"郝桥镇","130527200":"东三召乡","130527201":"阎里乡","130527202":"河郭乡","130527203":"史召乡","130527204":"三思乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130527.json
// module id = 227
// module chunks = 0